import { useEffect, useState } from 'react';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { db } from '../firebase';

const useInboxUnread = (userId?: string) => {
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (!userId) {
      setUnreadCount(0);
      return;
    }

    const q = query(
      collection(db, 'inboxItems'),
      where('userId', '==', userId),
      where('isRead', '==', false),
    );

    const unsubscribe = onSnapshot(
      q,
      (snap) => {
        const activeUnread = snap.docs.reduce((acc, d) => {
          const data = d.data() as { isArchived?: boolean };
          return data.isArchived ? acc : acc + 1;
        }, 0);
        setUnreadCount(activeUnread);
      },
      () => setUnreadCount(0),
    );

    return () => unsubscribe();
  }, [userId]);

  return { hasUnread: unreadCount > 0, unreadCount };
};

export { useInboxUnread };
export default useInboxUnread;






